import React from 'react';
import PropTypes from 'prop-types';
import FsLightbox from 'fslightbox-react';

import getConfig from 'next/config';
import Video from './components/Video';
import Image from './components/Image';
import styles from './styles.module.scss';

const {
	publicRuntimeConfig: { assetPrefix }
} = getConfig();

const Lightbox = ({ materials, toggler, onClose, slide }) => {
	const sources = materials.map((material) => (
		<div>
			{material.type === 'video' ? (
				<Video material={material} alone={materials.length === 1} />
			) : (
				<Image file={material} alone={materials.length === 1} />
			)}
			<style jsx global>
				{`
					.fslightbox-slide-btn::after {
						background: url('${assetPrefix}icons/white-arrow.svg');
					}
				`}
			</style>
		</div>
	));

	return (
		<div className={styles.lightbox}>
			<FsLightbox
				onClose={onClose}
				toggler={toggler}
				type="image"
				slide={slide || 1}
				sources={sources}
			/>
		</div>
	);
};

Lightbox.propTypes = {
	materials: PropTypes.arrayOf(PropTypes.object).isRequired,
	toggler: PropTypes.bool.isRequired,
	onClose: PropTypes.func,
	slide: PropTypes.number
};

Lightbox.defaultProps = {
	slide: 0
};

export default Lightbox;
